const createMemoryStorage = (): Storage => {
  const storage: Record<string, string> = {};
  return {
    get length() {
      return Object.keys(storage).length;
    },
    clear() {
      Object.keys(storage).forEach(key => delete storage[key]);
    },
    key(index: number) {
      const keys = Object.keys(storage);
      return keys[index] ?? null;
    },
    getItem(key: string) {
      return storage.hasOwnProperty(key) ? storage[key] : null;
    },
    setItem(key: string, value: string) {
      storage[key] = value;
    },
    removeItem(key: string) {
      delete storage[key];
    }
  };
};
export const getStorage = (name: string): Storage =>
  typeof window === 'object' && window[name] ? window[name] : createMemoryStorage();
